export default function getMigrationTrackingReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'GET_MIGRATION_TRACKING_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'GET_MIGRATION_TRACKING_ERROR':
            return {...state, ...{error: action.error}};

        case 'GET_MIGRATION_TRACKING_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}